import { IconProps } from "@/types/icons";

export const Linkedin = ({
  className,
  height = 20,
  width = 20,
  decorative = false,
  ariaLabel = "LinkedIn",
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <g id="icon" clipPath="url(#clip0_2888_1578)">
        <path
          id="icon_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.378002 15.3334V5.34915H3.47744V15.3334H3.54104H0.378002ZM0.00494397 2.55028C0.00249769 2.51483 5.11822e-05 2.47817 5.11822e-05 2.44272C-0.00728766 1.46984 0.775522 0.675399 1.74914 0.668066C1.79807 0.668066 1.84699 0.669288 1.89592 0.672955C2.85975 0.592289 3.70739 1.30728 3.78812 2.26917C3.79179 2.30583 3.79301 2.3425 3.79423 2.37794C3.80157 3.35083 3.01876 4.14526 2.04514 4.1526C1.99499 4.15382 1.94607 4.1526 1.89592 4.14771C0.932084 4.22838 0.0856712 3.51338 0.00494397 2.55028ZM12.459 15.3334V10.1524C12.459 8.82512 11.889 7.87668 10.6879 7.87668C9.92339 7.88157 9.24332 8.35946 8.98035 9.0769C8.92286 9.34701 8.90084 9.62323 8.91674 9.89823V15.2699H5.43813C5.43813 15.2699 5.50174 6.10692 5.43813 5.28437H8.91674V6.86469C9.51975 5.74025 10.7441 5.09126 12.0137 5.22204C14.2276 5.22204 15.9975 6.67525 15.9975 9.77234L15.9999 15.3334H12.459Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2888_1578">
          <rect
            width="15.9999"
            height="14.6667"
            fill="white"
            transform="translate(0 0.666748)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
